import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { useToken } from '@rexlabs/styling';
import Box from '@rexlabs/box';
import { useDownshiftContext, safeGetId } from '../../../../core';
import DefaultValue from '../../../shared/components/defaults/value';

function TagMultiSelectInputBase(_ref) {
  var disabled = _ref.disabled,
      innerRef = _ref.innerRef,
      Value = _ref.Value,
      props = _objectWithoutProperties(_ref, ["disabled", "innerRef", "Value"]);

  var _useDownshiftContext = useDownshiftContext(),
      selectedItems = _useDownshiftContext.selectedItems;

  var token = useToken();
  var hasItems = selectedItems.length > 0;
  return /*#__PURE__*/React.createElement(Box, {
    style: {
      overflow: 'hidden'
    },
    flex: 1,
    flexWrap: "wrap",
    sx: token('spacing.xs'),
    sy: "0.5rem"
  }, hasItems && _mapInstanceProperty(selectedItems).call(selectedItems, function (item, index) {
    var _item$Value;

    var RenderValue = (_item$Value = item === null || item === void 0 ? void 0 : item.Value) !== null && _item$Value !== void 0 ? _item$Value : Value;
    return /*#__PURE__*/React.createElement(DefaultValue, {
      key: safeGetId(item),
      disabled: disabled,
      item: item,
      index: index,
      Value: RenderValue
    });
  }), /*#__PURE__*/React.createElement("input", _extends({
    ref: innerRef
  }, props, {
    disabled: disabled
  })));
}

var TagMultiSelectInput = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(TagMultiSelectInputBase, _extends({}, props, {
    innerRef: ref
  }));
});
TagMultiSelectInput.displayName = 'TagMultiSelectInput';
export default TagMultiSelectInput;